<div class="nav-bar">

  <a class="logo row-centered" href="/">
    <img src="/assets/img/logos/white-text/Original.svg" alt="Cykubed app">
  </a>
</div>

<iframe src="https://api.cykubed.com/privacy"></iframe>
